// extracted by mini-css-extract-plugin
export default {"ellipsis":"AppBar_ellipsis__-MyBl","clickableLinks":"AppBar_clickableLinks__duPqt","\t":"AppBar_-__muaoJ"};